//#region react import
import { useState } from "react";
import { useSelector } from "react-redux";
//#endregion

//#region component import
import GstaToolTip from "../GstaToolTip/GstaToolTip.component";
//#endregion

//#region functions import
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region constants import
import { MAX_VISIBLE_MACHINES } from "./FormationMachineList.constant";
import { TRANSLATIONS } from "../../Constants/Translations";
//#endregion

//#region style import
import "./FormationMachineList.style.scss";
//#endregion

const FormationMachineList = ({ value }) => {
  //#region store hooks
  const translations = useSelector((state) => state.translationSlice.translations);
  //#endregion

  //#region constants
  const machines = value.machines || [];

  const renderMachines = () => {
    if (machines.length <= MAX_VISIBLE_MACHINES) {
      return (
        <div className="formation-machine-list without-tooltip">
          {machines.map((machine, index) => (
            <div
              key={machine.code + index}
              className="formation-machine-item"
            >
              <i className={`icon-${machine.code}`} />
              {getTranslations(machine.name, translations)}
            </div>
          ))}
        </div>
      );
    }
    return (
      <GstaToolTip
        toolTipContent={
          <div className="formation-machine-list with-tooltip">
            {machines.map((machine, index) => (
              <div
                key={machine.code + index}
                className="formation-machine-item"
              >
                <i className={`icon-${machine.code}`} />
                <span>{getTranslations(machine.name, translations)}</span>
              </div>
            ))}
          </div>
        }
      >
        <span className="formation-machine-item">
          {machines.length} {getTranslations(TRANSLATIONS.GSTA_VEHICLES_SELECTED, translations)}
        </span>
      </GstaToolTip>
    );
  };
  //#endregion

  return <div className="formation-machine-container">{renderMachines()}</div>;
};

export default FormationMachineList;
